import React, { useState } from 'react';
import ResourceItem from './ResourceItem';
import TimeIndicators from './TimeIndicators';
import ResourceTabs from './ResourceTabs';
const ResourceList = ({ resources = [], onLoadMore }) => {
    const [activeTab, setActiveTab] = useState('list');
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    return (React.createElement("div", { className: "bg-white rounded-md shadow-sm" },
        React.createElement(ResourceTabs, { activeTab: activeTab, onTabChange: handleTabChange }),
        React.createElement("div", { className: "divide-y" },
            resources.length > 0 ? (resources.map(resource => (React.createElement(ResourceItem, { key: resource.id, name: resource.name, capacity: resource.capacity, features: resource.features, timeSlots: resource.timeSlots, status: resource.status, isSelected: false })))) : (React.createElement("div", { className: "p-4 text-center text-gray-500" }, "No resources found. Try adjusting your filters.")),
            React.createElement(TimeIndicators, { date: new Date('2023-10-28') }),
            resources.length > 0 && (React.createElement("div", { className: "p-3 text-center" },
                React.createElement("button", { className: "text-blue-600 font-medium", onClick: onLoadMore }, "Load More..."))))));
};
export default ResourceList;
